module.exports = __webpack_public_path__ + "img/doctor.b691d519.png";